import { useConfirmationDialog } from '@openx/components-core/lib/Dialog/ConfirmationDialog/useConfirmationDialog.tsx';
import { useCallback, useRef } from 'react';
import { useTranslation } from 'react-i18next';

import {
  UploadFileDialogContent,
  type UploadFormExposedMethods,
} from '../components/UploadFileDialog/UploadFileDialogContent.tsx';

export const useUploadSegmentDialog = () => {
  const { t } = useTranslation();
  const formRef = useRef<UploadFormExposedMethods>(null);
  const {
    open: openConfirmationDialog,
    setCancelLabel,
    setLoading,
    toogleConfirmationDisabled,
    toogleConfirmationHidden,
  } = useConfirmationDialog();

  const open = useCallback(() => {
    openConfirmationDialog({
      confirmationButtonColor: 'primary',
      confirmationLabel: t('Upload'),
      content: (
        <UploadFileDialogContent
          ref={formRef}
          setCancelLabel={setCancelLabel}
          setDialogLoading={setLoading}
          toogleConfirmationDisabled={toogleConfirmationDisabled}
          toogleConfirmationHidden={toogleConfirmationHidden}
        />
      ),
      customContent: true,
      onCancel: () => {
        setCancelLabel(t('Cancel'));
        toogleConfirmationHidden(false);
      },
      onConfirmed: () => formRef?.current?.submitForm(),
      showExtraBtn: false,
      title: t('Upload Segment'),
    });
  }, [t, openConfirmationDialog, setCancelLabel, setLoading, toogleConfirmationDisabled, toogleConfirmationHidden]);

  return {
    open,
  };
};
